
































import { ClientRoutes } from "@/data/enums/router";
import { IInvoiceProvider } from "@/models/providers/invoice";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    "invoice-provider": () =>
      import("@/components/app/global/invoices/invoiceProvider.vue"),
    "invoice-details": () =>
      import("@/components/app/global/invoices/invoiceDetails.vue"),
    "payments-table": () =>
      import("@/components/app/global/invoices/paymentsTable.vue"),
    "delegated-object-message": () =>
      import("@/components/app/global/delegates/delegatedObjectMsg.vue")
  }
})
export default class ClientCreditNoteView extends Vue {
  public invoiceId = this.$route.params.invoiceId;

  public onNotFound(vm: IInvoiceProvider & Vue) {
    return vm.$router
      .push({ name: ClientRoutes.CREDIT_NOTES })
      .catch(err => err);
  }
}
